import {
  SET_USER_LOCATION,
  SHOW_SEARCH_FILTERS,
  SHOW_ACTIVE_FILTER,
  BROWSER_LOCATION_ALLOWED,
  BROWSER_LOCATION_DENIED,
  SET_ACTIVE_FILTER,
  SYMPTOMS_SUBMIT,
  CLEAR_SEARCH_PREFERENCES,
  SET_SEARCH_IN_MARKET_PLACE,
  SET_SEARCH_COVID_COST_TYPE,
  SET_SEARCH_PREFERENCES_PAGINATION_PARTNER_RADIUS,
} from '../constants/index';
import {
  SEARCH_NON_PARTNERS_RESPONSE_RECEIVED,
  SEARCH_PARTNERS_RESPONSE_RECEIVED,
} from '../ducks/searchResults';
import { DEFAULT_SEARCH_RADIUS, METERS_IN_A_MILE } from '../config/index';
import { URGENT_CARE_VALUE } from '../components/Home/Tiles/ProviderTypes';

export type SearchPagination = Partial<{
  partnersPage: number;
  nonPartnersPage: number;
  partnersRadius: number;
  nonPartnersRadius: number;
}>;

export type SearchLocation = GeoResponse & {
  cityLabel: string;
};

export type SearchPreferencesState = Partial<{
  displayActiveFilter: string;
  location: SearchLocation;
  outsideServiceArea: boolean;
  browserLocationAllowed: boolean;
  pagination: SearchPagination;
  showFilters: string;
  activeFilter: string;
  providerType: string;
  category: string;
  requestedInsurance: any;
  requestedServices: string;
  isServiceHardFilter: boolean;
  isCovidTestRelatedSearch: boolean;
  isFluRelatedSearch: boolean;
  isTelemed: boolean;
  isInMarketPlaceSearch: boolean;
  covidCostType: boolean;
}>;

const initialPagination: SearchPagination = {
  partnersPage: 1,
  nonPartnersPage: 1,
  partnersRadius: DEFAULT_SEARCH_RADIUS * METERS_IN_A_MILE,
  nonPartnersRadius: DEFAULT_SEARCH_RADIUS * METERS_IN_A_MILE,
};

export default function searchReducer(
  state: SearchPreferencesState = { pagination: initialPagination },
  action: any
): SearchPreferencesState {
  switch (action.type) {
    case SHOW_ACTIVE_FILTER:
      return {
        ...state,
        displayActiveFilter: action.payload.value,
      };
    case CLEAR_SEARCH_PREFERENCES:
      return { pagination: initialPagination };

    case SET_USER_LOCATION:
      return {
        ...state,
        location: {
          ...state.location,
          ...action.payload.value,
        },
        outsideServiceArea: false,
      };
    case BROWSER_LOCATION_ALLOWED:
      return {
        ...state,
        browserLocationAllowed: true,
      };
    case BROWSER_LOCATION_DENIED:
      return {
        ...state,
        browserLocationAllowed: false,
      };
    case SEARCH_PARTNERS_RESPONSE_RECEIVED: {
      const responsePagination = action.payload.value.response.pagination;
      const pagination = {
        ...state.pagination,
        partnersPage: responsePagination.page,
      };
      return {
        ...state,
        pagination,
      };
    }

    case SEARCH_NON_PARTNERS_RESPONSE_RECEIVED: {
      const responsePagination = action.payload.value.response.pagination;
      const pagination = {
        ...state.pagination,
        nonPartnersPage: responsePagination.page,
      };
      return {
        ...state,
        pagination,
      };
    }

    case SHOW_SEARCH_FILTERS:
      return {
        ...state,
        showFilters: action.payload.value,
      };
    case SET_ACTIVE_FILTER:
      return {
        ...state,
        activeFilter: action.payload.value,
      };
    case SYMPTOMS_SUBMIT:
      return {
        ...state,
        location: action.payload.value.location || state.location,
        providerType: action.payload.value.providerType || state.providerType || URGENT_CARE_VALUE,
        category: action.payload.value.category || state.category,
        requestedInsurance: action.payload.value.requestedInsurance || state.requestedInsurance,
        requestedServices: action.payload.value.requestedServices || state.requestedServices,
        isServiceHardFilter: action.payload.value.isServiceHardFilter ?? state.isServiceHardFilter,
        isCovidTestRelatedSearch:
          action.payload.value.isCovidTestRelatedSearch ?? state.isCovidTestRelatedSearch,
        isFluRelatedSearch: action.payload.value.isFluRelatedSearch ?? state.isFluRelatedSearch,
        isTelemed: action.payload.value.isTelemed,
      };
    case SET_SEARCH_IN_MARKET_PLACE:
      return {
        ...state,
        isInMarketPlaceSearch: action.payload.value.in_market,
      };
    case SET_SEARCH_COVID_COST_TYPE:
      return {
        ...state,
        covidCostType: action.payload.value,
      };
    case SET_SEARCH_PREFERENCES_PAGINATION_PARTNER_RADIUS:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          nonPartnersRadius: action.payload.value.nonPartnersRadius,
          partnersRadius: action.payload.value.partnersRadius,
        },
      };
    default:
      return state;
  }
}
